// @ts-strict-ignore
import { inject } from '@angular/core';
import { ResolveFn } from '@angular/router';
import { DashboardV4 } from '../../../public/dashboard/shared/model/dashboard-v4';
import { PublishedBoardBuilderService } from './published-board-builder.service';

export const v4Resolver: ResolveFn<DashboardV4> = (route, state) => {
  const boardId = route.params.boardId || route.data.boardId;
  const publishedBoardBuilder = inject(PublishedBoardBuilderService);
  return publishedBoardBuilder.buildDashboardV4(boardId);
};
